import PropTypes from 'prop-types'
import React from 'react'

import Icons from './Icons'

function ButtonIconClose({ onClick, className }) {
  return (
    <button className={`h-8 ${className}`} onClick={onClick}>
      <Icons.Close />
    </button>
  )
}

ButtonIconClose.propTypes = {
  onClick: PropTypes.func.isRequired,
  className: PropTypes.string,
}

export default ButtonIconClose
